import { Row, Col, Button } from 'react-bootstrap';
import { useHistory, useParams } from 'react-router';
import { Card } from 'components';
import { withStore } from 'store';
import { useWindowSize } from 'hooks';
import { priceFormat } from 'util/prices';
import styles from './styles.module.scss';

function PaymentCard({
  shoppingCartPrices = {},
  firstActionLabel = 'Comprar ahora',
  onClickPayNow,
  onClickFirstAction,
  secondActionLabel = 'Seguir comprando',
  onClickSecondAction,
}) {
  const [, { isMobile }] = useWindowSize();
  const history = useHistory();
  const { tableId } = useParams();

  const keepShopping = () => {
    if (tableId) {
      history.push(`/invitado/${tableId}`);
    }
  };

  return (
    <Card className={`${styles.paymentCard} ${(isMobile?'mt-0':'')}`}>
      <Row>
        <Col xs={12} className="d-flex justify-content-between">
          <p>Subtotal ({shoppingCartPrices.quantity} productos)</p>
          <p>${priceFormat(shoppingCartPrices.subtotal)} MXN</p>
        </Col>
        <Col xs={12} className="d-flex justify-content-between">
          <p>Descuento:</p>
          <p>${priceFormat(shoppingCartPrices.discount)} MXN</p>
        </Col>
        <Col xs={12} className="mb-2 mt-4">
          <h3 className={styles.title}>Total (IVA incluido)</h3>
          <h1 className={`${styles.price} text-primary font-weight-bold`}>
            ${priceFormat(shoppingCartPrices.total)} MXN
          </h1>
        </Col>
        <Col
          xs={12}
          className="mt-3 mb-2 d-flex flex-column justify-content-center align-items-center"
        >
          <Button
            block
            className={styles.actionButton}
            onClick={onClickFirstAction || onClickPayNow}
          >
            {firstActionLabel}
          </Button>
          <Button
            variant="secondary"
            block
            className={styles.actionButton}
            onClick={onClickSecondAction || keepShopping}
          >
            {secondActionLabel}
          </Button>
        </Col>
      </Row>
    </Card>
  );
}

export default withStore({
  mapStateToProps: (state) => ({
    shoppingCartPrices: state.externalGiftTable.shoppingCartPrices,
  }),
})(PaymentCard);
